"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerRichEditCustomContainerType = void 0;
var external_types_1 = require("./external-types");
function registerRichEditCustomContainerType(customContainerTypeName, richEditsHolder) {
    if (richEditsHolder.isContainerTypeRegistered(customContainerTypeName))
        return;
    richEditsHolder.registerContainerType(customContainerTypeName);
    external_types_1.WRE_NUSA_registerCustomContainerType(customContainerTypeName, function (customContainerType) {
        customContainerType.getFocussedElement = function (containerElement) {
            return containerElement;
        };
        customContainerType.setFocussedElement = function (element) {
            var rich = richEditsHolder.getRichEditByElement(element);
            rich.Focus();
        };
        richEditsHolder.registerContainerTypeObject(customContainerTypeName, customContainerType);
    });
}
exports.registerRichEditCustomContainerType = registerRichEditCustomContainerType;
